import React, { useRef } from "react"
import type { TModalSize } from "lib/components/Modal"
import { Modal } from "lib/components";
import { appTools, cn } from "lib/utils";
import { TriangleAlert as AlertIcon, Info as InfoIcon, Smile as SuccessIcon } from 'lucide-react';

export type TDialogType = "info"|"warning"|"error"|"success"

export default function DialogBox({ 
  size="sm",
  type="info",
  open=false, 
  hideFn, 
  className="",
  title="",
  accept,
  cancel={ label:"Cancel" },
  children 
}:{ 
  size:TModalSize 
  type?:TDialogType
  open?:boolean
  hideFn:any
  className?:string
  title?:string
  accept?:{ label:string, action:() => void }|undefined
  cancel?:{ label:string, action?:() => void }|undefined
  children?:any 
}) {

  function handleCancel(e:any){
    e.preventDefault()
    if( cancel && cancel.action ) cancel.action()
    hideFn()
  }

  function handleAccept(e:any){
    e.preventDefault()
    if( accept ) accept.action()
    hideFn()
  }

  return (
    <Modal 
      status={open ? "open" : "closed"} 
      size={size} 
      showCloseBtn={false} 
      ignoreOutsideClick={true} 
      onClose={hideFn}
      className="mt-10"
    >
      <div className="w-full h-full flex flex-col justify-between items-center">
        
        <div className="w-full h-8 flex justify-center items-center gap-2 pb-2 mb-2 border-b border-solid border-slate-700">
          <div>
            { (type === "error" || type === "warning") && <AlertIcon className="w-5 h-5 bg-transparent" /> }
            { type === "info" && <InfoIcon className="w-5 h-5 bg-transparent" /> }
            { type === "success" && <SuccessIcon className="w-5 h-5 bg-transparent" /> }
          </div>
          <div className="text-base text-neutral-300 uppercase tracking-wide">{ title || "Hmm...." }</div>
        </div>

        <div className="w-full h-full grow flex flex-col">
          { children }
        </div>

        { (accept !== undefined || cancel !== undefined) && (
          <div className="w-full h-8 flex justify-end items-center gap-3">
            
            { cancel !== undefined && (
              <button className="px-4 pt-.5 h-5 border border-solid border-slate-700 text-neutral-300 text-xs" onClick={handleCancel}>
                { cancel.label || "Cancel" }
              </button>
            )}

            { accept !== undefined && (
              <button className="px-4 pt-.5 h-5 border border-solid border-slate-700 text-neutral-300 text-xs" onClick={handleAccept}>
                { accept.label || "OK" }
              </button>
            )}
          </div>
        )}
      </div>
    </Modal>
  )

}